/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { CustomAppState } from "@eisinc/App/Store/Reducers";
import { getCurrentAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";

export function hasChanges(state: CustomAppState) {
    const {
        accountSettings: {
            editingAccount,
            initialUseDefaultCustomer,
            useDefaultCustomer,
            initialShipToId,
            selectedShipToId,
        },
    } = state.pages;
    const account = getCurrentAccountState(state).value;
    if (!account || !editingAccount) {
        return false;
    }

    const firstName = getAccountFirstName(state);
    const lastName = getAccountLastName(state);

    // xng-change: add firstname and lastname to the check to detect change
    return (
        account.email !== editingAccount.email ||
        (typeof firstName !== "undefined" && account.firstName !== firstName) ||
        (typeof lastName !== "undefined" && account.lastName !== lastName) ||
        account.setDefaultCustomer !== editingAccount.setDefaultCustomer ||
        account.isSubscribed !== editingAccount.isSubscribed ||
        account.defaultFulfillmentMethod !== editingAccount.defaultFulfillmentMethod ||
        account.defaultWarehouseId !== editingAccount.defaultWarehouseId ||
        useDefaultCustomer !== initialUseDefaultCustomer ||
        initialShipToId !== selectedShipToId
    );
}

export function getAccountFirstName(state: CustomAppState) {
    return state.accountNames.firstName;
}

export function getAccountLastName(state: CustomAppState) {
    return state.accountNames.lastName;
}
